import { isDuctedBundleSystem } from 'utils/compatibility-bundle-fields';
import { readExistingSystemUniqueId } from 'utils/compatibility-systems';
import { DuctedSwapCandidates } from 'utils/ducted-component-swap-types';
import useDuctedSectionSwapCandidates from './use-ducted-section-swap-candidates';

export default function useDuctedSwapCandidates(
  system: object | null | undefined
): DuctedSwapCandidates {
  const existingSystemUniqueId = isDuctedBundleSystem(system)
    ? null
    : readExistingSystemUniqueId(system);
  return useDuctedSectionSwapCandidates(existingSystemUniqueId);
}
